exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".index-module__modal___2R8PH{position:relative;background-color:red}.index-module__modal___2R8PH .index-module__bluepoly___XiCcP{position:absolute;display:block;width:600px;height:600px;left:-45px;top:-80px;background-image:url(/images/modal/blue.svg);background-repeat:no-repeat;z-index:-1}.index-module__modal___2R8PH .index-module__pinkpoly___56Txz{height:445px;left:-67px;bottom:-60px}.index-module__modal___2R8PH .index-module__pinkpoly___56Txz,.index-module__modal___2R8PH .index-module__yellowpoly____RFIX{position:absolute;display:block;width:500px;background-image:url(/images/modal/pink.svg);background-repeat:no-repeat;z-index:-1}.index-module__modal___2R8PH .index-module__yellowpoly____RFIX{height:440px;right:-93px;bottom:-65px}", ""]);

// exports
exports.locals = {
	"modal": "index-module__modal___2R8PH",
	"bluepoly": "index-module__bluepoly___XiCcP",
	"pinkpoly": "index-module__pinkpoly___56Txz",
	"yellowpoly": "index-module__yellowpoly____RFIX"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--6-1!./node_modules/sass-loader/lib/loader.js!./resources/assets/components/UI/ModalContainer/index.module.scss
// module id = qYUL
// module chunks = 0